module.exports = __webpack_public_path__ + "static/media/undraw_notify_88a4.f73e8112.svg";